import React from 'react';

/**
 * Animated background waves component
 */
export const BackgroundWaves = () => {
  return (
    <div className="bg-waves">
      <div className="wave"></div>
      <div className="wave"></div>
      <div className="wave"></div>
    </div>
  );
};
